import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=acaa05fa&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tables/table-basic.css?vue&type=style&index=0&id=acaa05fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa05fa",
  null
  
)

export default component.exports